<template>
  <b-row>
    <b-col>
      <h1>Connect to Square Payments</h1>
      <div class="square-logo">
        <img
          :src="squareLogoUrl"
          alt="Built with Square"
          class="square-brand-logo"
        >
      </div>
      <p>
        Get your funds fast. Square makes it easy for you to accept credit cards online with no
        commitments or monthly fees. Funds are deposited as soon as the next business day and
        you can get a free card reader to take payments in person.
      </p>

      <p>
        As a Square merchant, you have access to the best of Square: insightful sales reporting,
        online scheduling, customer engagement tools, and much more. Square is there for your
        business and your customers with everything from Chargeback Protection and phone support
        to data encryption and fraud monitoring.
      </p>

      <p>
        For more information on Square Payments, please visit
        <a
          href="https://squareup.com/pos/payments"
          target="_blank"
        >Learn more</a>.
      </p>
      <p>
        The connection process will redirect you to the Square Payments OAuth2 Verification Page
        (if you are have not already authorised the connection),
        where you will be asked to allow the application to connect to and use your
        Square Payment Account.
      </p>
      <loading-spinner v-if="loading">
        <div slot="title">
          Checking Connection to Square Payments
        </div>
        <div slot="message">
          Please wait while we check for an existing connection to Square Payments
        </div>
      </loading-spinner>

      <loading-spinner v-if="connecting && !loading">
        <div slot="title">
          Connecting to Square Payments
        </div>
        <div slot="message">
          Please wait while we verify your Square Payments Account
        </div>
      </loading-spinner>

      <template v-if="!loading && !connecting">
        <div v-if="isConnected">
          <square-payments-oauth2-service-connected />
        </div>
        <div v-if="!loading && !connecting && !isConnected">
          <b-form-group
            id="default-currency"
            description="The Default currency that all payments will be processed using."
            label="Default Currency"
            label-for="currency"
          >
            <b-form-select
              v-model="currency"
              :options="availableCurrency"
            />
          </b-form-group>
          <b-button
            primary
            :disabled="disableConnect"
            @click="connectsquare"
          >
            Connect
          </b-button>
        </div>
      </template>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'square-payments-oauth2-connect',
  props: {
    redirect: {
      type: String,
      required: false,
      default: '/square/oauth/redirect'
    },
    squareLogoUrl: {
      type: String,
      required: false,
      default: 'https://static.aspedia.net/assets/pos/square/brand_white-edcf1cc8a10da45f6d0e67215261bcd24f83a48336be84307d3ca62314963adf.png'
    }
  },
  data: function() {
    return {
      connecting: false,
      loading: false,
      currency: this.$store.state.square.dflt_currency
    }
  },
  computed: {
    availableCurrency: function() {
      return Object.entries(this.$store.state.square.currencies).reduce((acc, [value, text]) => ([...acc, { text, value }]), [])
    },
    disableConnect: function() {
      return this.connecting
    },
    isConnected: function() {
      return this.$store.getters['square/isConnected']
    }
  },
  mounted: function() {
    console.log('Square Payments OAuth2 Connect Component Mounted')
    this.loading = true
    this.$emit('loading', true)
    Promise.all([
      this.$store.dispatch('square/loadCurrencies'),
      this.$store.dispatch('square/getIsConnected', { force: true })
    ])
      .catch(err => {
        this.$emit('error', err)
      })
      .finally(_ => {
        this.currency = this.$store.state.square.dflt_currency
        this.loading = false
        this.$emit('loading', false)
      })
  },
  methods: {
    connectsquare: function() {
      this.$emit('connecting', true)
      this.connecting = true
      this.$store.dispatch('square/oauth2Connect', { redirect: this.redirect, currency: this.currency })
        .then(redirect => {
          this.$emit('connecting', false)
          window.location.href = redirect
        })
        .catch(err => {
          this.connecting = false
          this.$emit('connecting', false)
          this.$emit('error', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .square-logo {
    margin: 20px 0;
    img {
      width: 250px;
    }
  }

</style>
